import React, { useEffect, useRef, useState } from "react";
//import { useNavigate } from "react-router-dom";
//import gsap from "gsap";
//import shaan from "../assets/Shaan.png";
//import sholay from "../assets/sholay.png";

//const logos = [shaan, sholay, shaan, sholay];

// ===== FOOTER SWITCHES: change true to false to hide that part =====
//const SHOW_LOGOS = true;        // SHAAN / SHOLAY logo strip
//const SHOW_DESCRIPTION = true;  // "Sippy Films | Established 1951..." text
//const SHOW_BUTTON = true;       // "Discover the Legacy" button
const SHOW_SOCIAL = true;       // Facebook / Instagram / YouTube icons
const SHOW_COPYRIGHT = true;    // © 2026 line
// ====================================================================

export default function Footer() {
  //const navigate = useNavigate();
  //const logoTrackRef = useRef(null);
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(230);

  // Keep the spacer exactly as tall as the footer, whatever parts are shown
  useEffect(() => {
    const el = footerRef.current;
    if (!el) return;
    const update = () => setFooterHeight(el.offsetHeight);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <>
    
      {/* Spacer in normal flow so the fixed footer below never covers page content */}
      <div className="footer-spacer" style={{ height: footerHeight }} aria-hidden="true" />

      <footer className="site-footer" ref={footerRef}>
      
            {SHOW_SOCIAL && (
              <div className="social-links">
                <a href="https://www.facebook.com/sippyfilms" target="_blank" rel="noreferrer" aria-label="Facebook">
                  <svg className="social-icon" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .593 0 1.325v21.351C0 23.407.595 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0z"/></svg>
                </a>
                <a href="https://www.instagram.com/sippyfilms/" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <svg className="social-icon" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
                <a href="https://www.youtube.com/@sippyfilms" target="_blank" rel="noreferrer" aria-label="YouTube">
                  <svg className="social-icon" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                </a>
              </div>
            )}

            {SHOW_COPYRIGHT && <p className="copyright-text"> © 2026 Sippy Films Pvt. Ltd.</p>}
      </footer>

      <style>{`
        .site-footer {
          position: fixed;
          left: 0;
          bottom: 0;
          width: 100%;
          z-index: 900;
          background: rgba(0, 0, 0, 0.92);
          backdrop-filter: blur(10px);
          border-top: 1px solid rgba(255, 255, 255, 0.08);
          padding: 18px 0;
          display: flex;
          justify-content: center;
        }

        .footer-container { width: 90%; max-width: 1200px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
        .logo-looper-container { width: 100%; overflow: hidden; mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent); -webkit-mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent); }
        .logo-track-gpu { display: flex; gap: 60px; width: max-content; align-items: center; }
        .footer-brand-logo { height: 36px; opacity: 0.5; }
        .footer-details { display: flex; flex-direction: column; align-items: center; gap: 8px; width: 100%; font-family: 'Sippy', sans-serif; }
        .desc-col p { margin: 0; text-align: center; font-size: 0.8rem; }
        .cta-gold-btn { background: transparent; border: 1px solid #0093c0; color: white; padding: 8px 40px; text-transform: uppercase; letter-spacing: 3px; cursor: pointer; font-size: 0.75rem; transition: all 0.3s ease; }
        .cta-gold-btn:hover { background: white; color: black; }

        .social-links { display: flex; gap: 16px; margin: 0; align-items: center; }
        .social-icon { width: 20px; height: 20px; fill: rgba(255, 255, 255, 0.6); transition: all 0.3s ease; }
        .social-icon:hover { fill: #0093c0; transform: translateY(-2px); }

        .copyright-text { font-family: 'SippyBold', sans-serif; font-size: 0.9rem; opacity: 0.7; margin: 2; margin-left: 14px; }

        @media (max-width: 768px) {
          .site-footer { padding: 14px 0; }
          .footer-brand-logo { height: 28px; }
          .logo-track-gpu { gap: 36px; }
          .cta-gold-btn { padding: 8px 28px; width: 80%; max-width: 240px; }
        }
      `}</style>
    </>
  );
}